<template>
  <div v-if="!searching">
    <!-- 2 options, transfer using nameservers or using dns servers -->
    <div class="columns mt-10 has-text-centered-mobile">
      <div class="column">
        <i18n
          class="is-size-2 has-text-dark has-text-weight-bold"
          path="domains.transfers.to_us"
          tag="p"
        >
          <span
            slot="domain_name"
            :style="{fontWeight: 'bold', textTransform: 'uppercase'}"
          >
            '{{ $route.query.term }}'
          </span>
        </i18n>
      </div>
    </div>
    <div class="columns has-text-centered-mobile">
      <div class="column">
        <div class="card">
          <div class="card-content">
            <p class="title">
              {{ $t('domains.transfers.point_with_ns') }}
            </p>
            <p class="subtitle">
              ({{ $t('common.recommended') }})
            </p>
          </div>
          <div class="card-content">
            <p class="is-medium">
              {{ $t('domains.transfers.ns_instructions') }}
            </p>
            <br>
            <p class="is-medium">
              dns1.register.com <br>
              dns2.register.com
            </p>
            <br>
            <p class="is-medium has-text-weight-bold">
              {{ $t('domains.transfers.note') }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="columns has-text-centered-mobile">
      <div class="column">
        <div class="card">
          <div class="card-content">
            <p class="title">
              {{ $t('domains.transfers.point_with_records') }}
            </p>
            <p class="subtitle">
              ({{ $t('common.advanced') }})
            </p>
          </div>
          <div class="card-content">
            <p class="is-medium">
              {{ $t('domains.transfers.record_instructions') }}
            </p>
            <br>
            <p class="is-medium">
              DNS A: 185.58.213.107 <br>
              DNS A: 185.58.213.106 <br>
              DNS A: 185.58.213.105 <br>
              DNS A: 185.58.213.19 <br>
              DNS CNAME: {{ $route.query.term }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import domainRegistrationMixin from '@/mixins/domain-registration'
export default {

  name: 'DomainTransfer',
  mixins: [domainRegistrationMixin],
  beforeMount () {
    // prevent user from accessing transfer page without a domain name to transfer in the query string
    if (!this.$route.query.term) {
      this.$router.replace({ name: 'DomainRegistration' })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

.transfer-box {
  padding: 10px;
  border: 1px solid $primary-base-color;
  color: $primary-base-color;
}
.mt-10 {
  margin-top: 10px;
}
.button {
  height: 50px;
  color: $white;
  background: $primary-base-color;
  border: 2px solid $white;
  width: 100%;
}
.card {
  padding: 20px;
}

</style>
